// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pricing {
  width: 100vw;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 5rem 0;
  margin-bottom: 7rem;

}

.pricing-container {
  width: 100%;
  gap: 3rem;
  display: flex;
  /* align-items: center; */
  justify-content: center;
}

.pricing-card {
  height: 41rem;
  border-radius: 16px !important;
  border: 1px solid #e9d9fb !important;
  transition: border 0.3s ease-in-out !important;
  background-color: #faf9fb !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.pricing-card:hover {
  border: 1px solid #a61bc2 !important;
}

.pricing_title {
  font-family: "Sora", sans-serif !important;
  font-weight: bold !important;
}

.pricing-btn {
  background: #a61bc2 !important;
  color: white;
  font-weight: 600;
  padding: 0.5rem 3.5rem !important;
  margin-top: auto;
  /* margin-bottom: auto; */
}

.pricing_btn {
  background: #a61bc2 !important;
  color: white;
  font-weight: 600;
  padding: 0.5rem 3.5rem !important;
  margin-top: auto;
  /* margin-bottom: auto; */
}

.pricing-btn:hover {
  color: white;
  opacity: 0.75;
}

.pricing-still-in-doubt {
  cursor: pointer;
  color: gray;
  font-weight: 500;
  margin-top: 1rem !important;
  margin-bottom: 0rem !important;
  text-decoration: underline;
}

.pricing-still-in-doubt:hover {
  opacity: 0.75;
}

@media screen and (max-width: 475px) {
  .pricing-container {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pricing/pricing.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;;AAErB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,oCAAoC;EACpC,8CAA8C;EAC9C,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".pricing {\n  width: 100vw;\n  margin-left: auto;\n  margin-right: auto;\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin: 5rem 0;\n  margin-bottom: 7rem;\n\n}\n\n.pricing-container {\n  width: 100%;\n  gap: 3rem;\n  display: flex;\n  /* align-items: center; */\n  justify-content: center;\n}\n\n.pricing-card {\n  height: 41rem;\n  border-radius: 16px !important;\n  border: 1px solid #e9d9fb !important;\n  transition: border 0.3s ease-in-out !important;\n  background-color: #faf9fb !important;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.pricing-card:hover {\n  border: 1px solid #a61bc2 !important;\n}\n\n.pricing_title {\n  font-family: \"Sora\", sans-serif !important;\n  font-weight: bold !important;\n}\n\n.pricing-btn {\n  background: #a61bc2 !important;\n  color: white;\n  font-weight: 600;\n  padding: 0.5rem 3.5rem !important;\n  margin-top: auto;\n  /* margin-bottom: auto; */\n}\n\n.pricing_btn {\n  background: #a61bc2 !important;\n  color: white;\n  font-weight: 600;\n  padding: 0.5rem 3.5rem !important;\n  margin-top: auto;\n  /* margin-bottom: auto; */\n}\n\n.pricing-btn:hover {\n  color: white;\n  opacity: 0.75;\n}\n\n.pricing-still-in-doubt {\n  cursor: pointer;\n  color: gray;\n  font-weight: 500;\n  margin-top: 1rem !important;\n  margin-bottom: 0rem !important;\n  text-decoration: underline;\n}\n\n.pricing-still-in-doubt:hover {\n  opacity: 0.75;\n}\n\n@media screen and (max-width: 475px) {\n  .pricing-container {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
